import {TimeSpan} from "@sparkware/app-utils";
import {action, makeObservable, observable} from "mobx";
import {delay} from "../../../utils/delay";
import {ServiceBase} from "../ServiceBase";
import {LocalStorageKeys} from "../storage/local-storage-keys";
import {IMagic8BallService} from "./magic-8-ball.service.interface";
import {
    InGameChallengesController_GetActiveTicketsResponse
} from "../api/api.service";

const TOOLTIP_DELAY = 0;
const TOOLTIP_TIMEOUT = 5000;

export class Magic8BallService extends ServiceBase implements IMagic8BallService {

    get progressPercentage(): number {
        return this.services.inGameChallenge.currentProgressPercentage;
    }

    @observable
    availableTicketCount: number = 0;

    @observable
    showIntent: boolean = false;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    get isEnabled() {
        if(!this.services.configuration.servicesConfigs.InGameChallenges.isMagic8BallEnabled) {
            return false;
        }

        return this.services.inGameChallenge.hasActiveCampaign;
    }

    async attemptShowTooltip(attachElement: HTMLDivElement) {
        const tooltipWasShown = this.services.localStorage.getItem(LocalStorageKeys.tooltipShownIGC) === null;
        if (!tooltipWasShown) {
            return;
        }

        await delay(TimeSpan.fromMilliseconds(TOOLTIP_DELAY));
        const gameRunner = await this.services.gameRunner;

        const showTooltip = () => {
            this.services.regularTooltips.showTooltip({
                attachTo: attachElement,
                renderContent: () => <>
                    {this.services.translation.translate("MAGIC_8_BALL_TOOLTIP_ROW1")}<br />
                    {this.services.translation.translate("MAGIC_8_BALL_TOOLTIP_ROW2")}
                </>,
                timeout: TimeSpan.fromMilliseconds(TOOLTIP_TIMEOUT),
                closeOnScroll: true,
                closeOnClickOutside: true,
                zIndex: gameRunner.gameFrameZIndex + 1,
                styling: {
                    maxWidth: "45rem"
                },
                onTooltipRendered: () => {
                    this.services.localStorage.setItem(LocalStorageKeys.tooltipShownIGC, true);
                }
            });
        }

        if (gameRunner.currentRunningGame) {
            return gameRunner.currentRunningGame.executeAnimationCompleteAction({
                execute: async () => {
                    // this.services.analytics.sendOrbitUserFlowEvent(ANALYTICS_CATEGORY, 'stopCurrentGameAutoplay', `modalZIndex: ${modalZIndex}`);
                    if (gameRunner.currentRunningGame) { // We check for currentRunningGame because it possible that meanwhile the game to be closed and there is no current running game.
                        try {
                            await gameRunner.currentRunningGame.gameCommunicationChannel.stopAutoplay();
                        } catch (err) {
                            this.services.logger.error(`Failed to send stopAutoplay for game ${gameRunner.currentRunningGame.gameInfo.gameType}`);
                        }
                    }
                    showTooltip();
                }
            });
        } else {
            return showTooltip();
        }
    }


    @action
    showMagicBall() {
        this.showIntent = true;
    }

    @action
    hideMagicBall() {
        this.showIntent = false;
    }

    async getTicketsAsync(): Promise<InGameChallengesController_GetActiveTicketsResponse["data"]["tickets"]> {
        return (await this.services.api.inGameChallengesController.getActiveTickets()).data.tickets;
    }
}